<template>
    <BaseModal modal-id="modalDocument" :show-modal="showModalActive" :isSizedUp="true" :isOverflow="true">
      <template #heading class="heading">Transaction Document
      </template>
      <template #content>
    
          <div class="app-modal-basic" @focus="getFocus()">
            <div class="headerDoc">
                <div class="docLogo">
                    <img src="@ridmv/web-themes/images/logo.png"  alt="RI DMV logo" class="dmv-logo"/>
                </div>
                <div>
                    <h5>STATE OF RHODE ISLAND</h5>
                    <h3>             
                        DIVISION OF MOTOR VEHICLES          
                    </h3>
                    <p class="address">600 New London Avenue <br />
                        Cranston RI 02920-3024<br />
                        Web Address: <a href="WWW.DMV.RI.GOV">WWW.DMV.RI.GOV</a>
                    </p>
                </div>
                <div class="barCode">
                    <span class="code">
                        <img class="barCode-doc" :src="`data:image/png;base64,${ templateData.barcode }`" alt="Certificate barcode" >
                    </span>
                </div>
            </div>
            <div class="bodyDoc">
                <div class="userDetails">
                    <p>{{templateData.customerName }}</p>
                    <p>{{templateData.customerAddress }}</p>
                    <p>{{templateData.cityStateZip }}</p>
                </div>
                <div class="date">
                    <p>Date: <strong>{{new Date().toLocaleDateString()}}</strong></p>
                </div>
                
            </div>
            <table width="0" border="border-style: solid; width: 0px;" height="263" style="width: 900px; border-collapse: collapse;" aria-describedby="mydesc">
                <caption class="doc-title">Registration Certificate {{ templateData.IsTransferable}}</caption>
            <tbody>
            <tr>
            <th id="regNumber" style="width: 411.5px;">
            <span>REG NUMBER:</span> 
            <p><b>{{ templateData.registrationNumber}}</b></p> 
            </th>
            <th id="plateType" style="width: 253.283px;">
            <span>PLATE TYPE:</span>
            <p><b>{{ templateData.plateType}}</b> </p>
            </th>
            <th id="plateDesign" style="width: 540.333px;">
            <span>PLATE DESIGN:</span>
            <p>  <b>{{ templateData.plateDesign}}</b></p>
            </th>
            <th id="vehicleType" style="width: 415.467px;">
            <span>VEHICLE TYPE:</span>
            <p> <b> {{ templateData.vehicleType}}</b></p>
            </th>
            <th id="driverLicense" style="width:342.417px;">
            <span>DRIVERS LICENSE:</span>
            <p> <b>{{ templateData.license}}</b> </p>
            </th>
            <th id="regExpDate" style="width: 446.333px;">
            <span>REG EXP DATE:</span>
            <p><b>{{ templateData.registrationExpirationDate}}</b> </p>
            </th>
            </tr>
            <tr>
            <th id="year" >
            <span>YEAR:</span>
            <p><strong> {{ templateData.modelYear}}  </strong></p>
            </th>
            <th id="make">
            <span>MAKE:</span>
            <p><strong>  {{ templateData.make}}  </strong></p>
            </th>
            <th id="model">
            <span>MODEL:</span>
            <p><strong>  {{ templateData.model}}   </strong></p>
            </th>
            <th id="bodyType">
            <span>BODY TYPE:</span>
            <p><strong>  {{ templateData.bodyType}} </strong></p>
            </th>
            <th id="majorColor">
            <span>MAJOR COLOR:</span>
            <p><strong>  {{ templateData.majorColor}} </strong></p>
            </th>
            <th id="minorColor">
            <span>MINOR COLOR:</span>
            <p><strong>  {{ templateData.minorColor}}  </strong></p>
            </th>
            </tr>
            <tr>
            <th colspan="2" id="vin">
            <span>VEHICLE IDENTIFICATION NUMBER:</span>
            <p><strong>  {{ templateData.vinNumber}}  </strong></p>
            </th>
            <th id="renewalFee">
            <span>RENEWAL FEE:</span>
            <p><strong>  {{ templateData.renewalFee}}</strong></p>
            </th>
            <th id="grossWeight">
            <span>GROSS WEIGHT:</span>
            <p><strong>  {{ templateData.grossWeight}}      </strong></p>
            </th>
            <th id="num of passengers">
            <span># OF PASSENGERS:</span>
            <p><strong>  {{ templateData.numberOfPassenger}}    </strong></p>
            </th>
            <th id="num of cylinders">
            <span># OF CYLINDERS:</span>
            <p><strong>  {{ templateData.numberOfCylinder}}  </strong></p>
            </th>
            </tr>
            <tr>
            <th colspan="2" id="fuelType">
            <span>FUEL TYPE:</span>
            <p><strong> {{ templateData.fuelType}} </strong></p>
            </th>
            <th id="carryingCapacity">
            <span>CARRYING CAPACITY:</span>
            <p><strong>{{ templateData.carryingCapacity}} </strong></p>
            </th>
            <th id="length">
            <span>LENGTH:</span>
            <p><strong>  {{ templateData.vehicleLength}}   </strong></p> 
            </th>
            <th id="CC's">
            <span>CCs:</span>
            <p><strong>  {{ templateData.cc}}</strong></p>
            </th>
            <th id="maxSpeed">
            <span>MAX SPEED:</span>
            <p><strong>  {{ templateData.maxSpeed}} </strong></p>
            </th>
            </tr>
            <tr>
            <th class="regOwner" style="width: 400px;" id="registeredOwner">
                <span>REGISTERED OWNER:</span>
                </th>
            <th colspan="2" id="registeredOwnerDetails">
                <p><strong>  {{ templateData.firstOwnerName}} </strong> <br />
                <strong>{{ templateData.firstOwnerAddress}} </strong> <br />
                <strong>{{ templateData.firstOwnerCityStateZip}} </strong></p>
            </th>
            <th class="regOwner" id="secondowner">
                <span >SECOND OWNER:</span>
                </th>
            <th colspan="2" id="secondOwnerDetails">
                <p><strong>  {{ templateData.secondOwnerName}}   </strong> <br />
                <strong>    {{ templateData.secondOwnerAddress}}   </strong> <br />
                <strong>  {{ templateData.secondOwnerCityStateZip}}</strong></p>
            </th>
            </tr>
            </tbody>
            </table>
            <ul class="list">
            <li class="riTitle">RI TITLE: <strong>{{ templateData.isPrintTitle}}</strong></li>
            <li>Notice: The law requires that the DMV be notified within 10 days of any change in name or address. Please visit our website to update your address online.</li>
            <li>Every registration plate shall <span>be at all times</span> securely fastened in a horizontal position and be in a condition to be clearly legible. Validation stickers are only to be placed securely on the lower right corner of the registration plate.</li>
            <li>Registration Certificate <span>shall at all times</span> be carried in the vehicle to which it refers or shall be carried by the person driving or in control of such vehicle.</li>
            <li>Proof of valid insurance/financial security is required as per Rhode Island General Laws &sect; 31-47 (Motor Vehicle Reparations Act).</li>
            <li>It is your responsibility to renew your registration prior to the expiration date. Failure to do so may result in the assignment of new plates.</li>
            <li>Failure to obtain an <strong>Emissions and/or Safety Inspection </strong>on or before <strong>  {{ templateData.inspectionDeadlineDate}} </strong> will result in this vehicle being suspended.</li>
            <li>Not valid without official signature of Administrator.</li>
            <li>Any vehicle operating <span>in excess of</span> legal weight limits is required to have an overweight permit per Chapter 31-25 of the Rhode Island General Laws. Failure to obtain an overweight permit may result in the imposition of fines and/or other penalties.</li>
            </ul>
            <div class="doc-footer">
                <p class="doc-sign"><img src="static/Signature.png"  alt="RI DMV logo" class="doc-signature" /> </p>
                <div>
                    <p class="doc-admin">
                        <span class="datefield">{{new Date().toLocaleDateString()}}</span>
                        WALTER R. CRADDOCK <br />
                        Administrator <br />
                        Division Of Motor Vehicles
                    </p>
                </div>
            </div>
        </div>
      </template>
      <template #footing>
        <BaseButtonGroup>
          <template #default>
            <button class="app-btn-primary" @click.prevent="handlePrint('print')">
             Print (Please use Portrait mode)
            </button>
            <button class="btn-close"  @click.prevent="handleClose()">
              Close
            </button>
          </template>
        </BaseButtonGroup>
      </template>

    </BaseModal>
    
  </template>
    
  <script>
    import { mapGetters, mapState ,mapActions} from 'vuex'
    import BaseModal from '@/components/ui/BaseModal'
    import BaseButtonGroup from '@/components/ui/BaseButtonGroup'
    import * as COMMONS from '../../store/_commons'
  
    export default {
      name: 'ModalDocument',
      components: {
        BaseModal,
        BaseButtonGroup,
      },
      props: {
        showModalActive: {
            type: Boolean,
            required: false,
        },
      },
      data() {
        return {
          bindEscKey: false,
          modalDetails: {
      
           
          },
        //   templateData: []
        };
      },
      computed: {
        ...mapGetters({
          statusInfo: COMMONS.GUEST_LOGIN_STATUS_INFO,
          personalInfo: COMMONS.GUEST_PERSONAL_INFO,
          outputDocumentInfo: COMMONS.GUEST_OUTPUT_DOCUMENT_INFO,
        }),
        ...mapState([
            //   'networkResponse',
          ]),
        templateData() {
            return this.$store.state.guestLogin.outputDocumentInformation;
        }
      },
      mounted() {        
  
        },
  
      methods: {
        ...mapActions({
          continueSession: COMMONS.GUEST_LOGIN_EXTEND_LOGIN,
          getOutputDocument: COMMONS.GUEST_OUTPUT_DOCUMENT,
        }),
        getOutputDocuments() {
            this.getOutputDocument()
        },
        
        handleClose()
        {
          this.$emit('getOutputDocumentCancel','No');
          this.$store.state.guestLogin.modalDocumentType = false;
        },
        handlePrint() {
            window.print();
        },

        getFocus() { 
            let element = document.getElementsByClassName("app-modal-basic");
            element.scrollTo({top: 0})
            document.body.scrollTop = 0;

            document.documentElement.scrollTop = 0;
        }
      
      },
  
    }
  </script>
    
  <style lang="scss" scoped>
  // TODO: should have been picked up from @ridmv/web-themes but it's not...
  .app-modal-basic {
    display: block;
    color: #050101 !important;
    .headerDoc{
        display: flex;
        align-items: flex-start;
        gap: 1.2rem;
        .docLogo{
            width: 140px;
            img {
                width: 100%;
            }
        }  
        h3{
            color: black;
        } 
        h5 {
            font-size: 16px;
        }
        .address{
            padding-top: 0rem;
        }
        .barCode {
            .code{
            background-color: white;
            display: inline-block;
            padding: 1em 0 0.05em 0.35em;
            margin-bottom: 1em;
            margin-left: 8em;
            }
        }
    }
    .bodyDoc{
        display: flex;
        justify-content: space-between;
        .userDetails{
            display: block;
            gap: 0.1rem;
            margin-top: 25px;
            text-align: left;
            font-weight: bold;
            p{
                line-height: 0.5em !important;
            }
        }
    }
    h3 {
        color: black;
        margin-bottom: 5px;
    }
    .doc-title{
        text-align: center;
        margin-top: 1.2rem;
        margin-bottom: 1.2rem;
        color: black;
        font-size: 1.125rem;
        font-weight: 700;
    }
    .date{
        text-align: right;
        margin-top: 25px;
    }
    .riTitle {
        margin-top: 1.5rem !important;
    }
    table {  
        width: 100% !important;
        span {
            font-size: 12px;
            font-weight: 500;
        }
        p {
            font-size: 16px;
            line-height: 18px !important;
        }
        tr {
            line-height: 10px;
            text-align: left;
            .regOwner {
                vertical-align: top;
                
            }
        }
    }
    .list {
            list-style: initial;
            margin-left: 1rem;
        }
    .doc-footer {
        .doc-sign{
            text-align: right;
            .doc-signature{
                width: 25%;
                height: 40%;
            }
        }
        .doc-admin{
            display: flex;
            align-items: center;
            text-align: justify;
            justify-content: space-between;

            .datefield{
                text-align: left;
            }
        }
    }
  }  


  @media only screen and (max-width: 599px) {
    .app-modal-basic {
        display: block;
        color: #050101 !important;
        .headerDoc{
            display: flex;
            align-items: flex-start;
            gap: 0.5rem;
            .docLogo{
                width: 45px;
                img {
                    width: 45px;
                }
            }  
            h3{
                color: black;
                font-size: 12px;
            } 
            h5 {
                font-size: 9px;
            }
            .address{
                padding-top: 0rem;
                font-size: 10px;
                display: block;
                line-height: 12px;
            }
            .barCode {
                .code{
                    background-color: white;
                    display: inline-block;
                    padding: 1em 0 0.05em 0.35em;
                    margin-bottom: 1em;
                    margin-left: 0em !important;

                    img {
                        width: 130px;
                    }
                }
            }
        }
        .bodyDoc{
            display: flex;
            justify-content: space-between;
            .userDetails{
                display: block;
                margin-top: 15px;
                text-align: left;
                font-weight: bold;
                p{
                    line-height: 0.5em !important;
                    font-size: 12px;
                }
            }
            .date{
                text-align: right;
                margin-top: 15px;
            p{
                font-size: 12px !important;
            }
            }
        }
        h3 {
            color: black;
            margin-bottom: 5px;
        }
        .doc-title{
            text-align: center;
            margin-top: 0.75rem;
            margin-bottom: 0.75rem;
            font-size: 14px;
        }
        .riTitle {
            margin-top: 1.5rem !important;
        }
        table {  
            width: 100% !important;
            span {
                font-size: 8px;
                font-weight: 500;
            }
            p {
                font-size: 10px;
                line-height: 14px !important;
            }
            tr {
                line-height: 10px;
                text-align: left;
                .regOwner {
                    vertical-align: top;
                    
                }
            }
        }
        .list {
                list-style: initial;
                margin-left: 1rem;
                font-size: 10px;
            }
        .doc-footer {
            .doc-sign{
                text-align: right;
                padding-bottom: 0em;
                .doc-signature{
                    width: 35%;
                    height: 40%;
                }
            }
            .doc-admin{
                display: flex;
                align-items: center;
                text-align: justify;
                justify-content: space-between;
                font-size: 10px;
                padding-top: 0em;

                .datefield{
                    text-align: left;
                }
            }
        }

        @media print {
            @page {
            }
            .app-modal-basic {
                visibility: visible;
                /**Remove scrollbar for printing.**/
                overflow: visible !important;
            }
        }
    } 
  
    .app-button-group{
        display: flex;
        .app-btn-primary,.btn-close{
            min-width: 70px;
            height: 36px;
            font-size: 12px;
        }
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 999px)  {
    .app-modal-basic {
        display: block;
        color: #050101 !important;
        .headerDoc{
            display: flex;
            align-items: flex-start;
            gap: 1.5rem;
            .docLogo{
                width: 75px;
                img {
                    width: 75px;
                }
            }  
            h3{
                color: black;
                font-size: 12px;
            } 
            h5 {
                font-size: 9px;
            }
            .address{
                padding-top: 0rem;
                font-size: 10px;
                display: block;
                line-height: 12px;
            }
            .barCode {
                .code{
                    background-color: white;
                    display: inline-block;
                    padding: 1em 0 0.05em 0.35em;
                    margin-bottom: 1em;

                    img {
                        width: 130px;
                    }
                }
            }
        }
        .bodyDoc{
            display: flex;
            justify-content: space-between;
            .userDetails{
                display: block;
                margin-top: 15px;
                text-align: left;
                font-weight: bold;
                p{
                    line-height: 0.5em !important;
                    font-size: 12px;
                }
            }
            .date{
                text-align: right;
                margin-top: 15px;
            p{
                font-size: 12px !important;
            }
            }
        }
        h3 {
            color: black;
            margin-bottom: 5px;
        }
        .doc-title{
            text-align: center;
            margin-top: 0.75rem;
            margin-bottom: 0.75rem;
            font-size: 14px;
        }
        .riTitle {
            margin-top: 1.5rem !important;
        }
        table {  
            width: 100% !important;
            span {
                font-size: 8px;
                font-weight: 500;
            }
            p {
                font-size: 10px;
                line-height: 18px !important;
            }
            tr {
                line-height: 10px;
                text-align: left;
                .regOwner {
                    vertical-align: top;
                    
                }
            }
        }
        .list {
                list-style: initial;
                margin-left: 1rem;
                font-size: 10px;
            }
        .doc-footer {
            .doc-sign{
                text-align: right;
                padding-bottom: 0em;
                .doc-signature{
                    width: 20%;
                    height: 40%;
                }
            }
            .doc-admin{
                display: flex;
                align-items: center;
                text-align: justify;
                justify-content: space-between;
                font-size: 10px;
                padding-top: 0em;

                .datefield{
                    text-align: left;
                }
            }
        }
    }

  }

  </style>

  <style scoped>
    #modalDocument .app-modal .app-modal-content.__large {
        width: 100% !important;
    }
    @media print{
        .app-modal-content .__overflow {      
            overflow-y: hidden !important;
            width: 100% !important;
        }

        @page { 
        }
        #modalDocument {
        }
        .heading{
            display: none;
        }
         .app-modal-basic{
            background-color: var(--print-background);
            color: var(--print-font-color);
            padding: 1em 0;
            display: block;
            width: 100% !important;
            visibility: visible;
            /**Remove scrollbar for printing.**/
            overflow: visible !important;

            .headerDoc{
                display: flex;
                align-items: flex-start;
                gap: 1.5rem !important;

                .docLogo{
                    .dmv-logo{
                        width: 120px !important;
                    }
                }  
                h3{
                    color: black;

                    width: 300px;
                } 
                h5 {

                }
                .address{
                    padding-top: 0rem;
                }

                p{

                }
                .barCode { 
                    .code{

                        .barCode-doc {
                            width: 125%;
                            height: 90px;
                            align-items: end;
                        }
                    }
                }
            }
            .bodyDoc{
                display: flex;
                justify-content: space-between;
                .userDetails{
                    display: block;
                    margin-top: 10px !important;
                    text-align: left;
                    p{
                    }
                }
                .date{
                    text-align: right;
                    p{
                    }
                }
            }
            h3 {
                color: black;
            }
            .doc-title{
                text-align: center;
                margin-top: 0.1rem !important;
                margin-bottom: 0.5rem !important;
            }
            .riTitle {
                margin-top: 0.5rem !important;
            }

            table { 
                width: 100% !important; 
                text-align: right;

                span {
                }
                p {
                }
                tr {
                    
                    text-align: left;
                    .regOwner {
                        vertical-align: top;
                        
                    }
                    th {
                        width: 16.6% !important;
                    }
                }
            }
            .doc-footer {
                .doc-sign{
                    text-align: right;
                    .doc-signature{
                        width: 30% !important;
                        height: 25% !important;
                    }
                }

                p{
                    padding-top: 0em !important;
                    padding-bottom: 0em !important;
                }
                .doc-admin{

                    .datefield{
                    }
                }
            }
        } 
    }
  </style>

  
    